import AccountManagementPage from "../../../components/shared/accounts/AccountManagementPage";
import { MANAGER_STAFF_CONFIG } from "../../../constants/accountManagementConfig";

const ManagerStaffListPage = () => <AccountManagementPage config={MANAGER_STAFF_CONFIG} />;

export default ManagerStaffListPage;
